import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { RootState } from "../state/reducers";
import { appInfo } from "../AppInfo";

type HubContextType = {
    children: React.ReactNode
}

type HubStoreType = {
    _connectionServer: any
}

const HubContext = createContext({} as HubStoreType);
const useHubContext = () => useContext(HubContext);
const reConnectTime: number = 5000;

const HubProvider = ({ children }: HubContextType) => {
    const { user_info } = useSelector((state: RootState) => state.auth)
    const [connectionServer, setConnectionServer] = useState<any>(null);

    const store: HubStoreType = {
        _connectionServer: connectionServer
    }
    useEffect(() => {
        if (user_info) {
            const domain = appInfo.baseApiURL.includes("http") ? appInfo.baseApiURL.replace("/api", "") : window.location.origin;
            const newConnection = new HubConnectionBuilder()
                .withUrl(domain + "/hubs/email?userId=" + (user_info?.user_id ?? 0).toString())
                .withAutomaticReconnect()
                .build();

            setConnectionServer(newConnection);
        }
    }, [user_info]);

    useEffect(() => {
        if (connectionServer) {
            connectionServer.start()
                .then((result: any) => {
                    console.log('ConnectionServer Connected!');
                    // connectionServer.on('NEW_NOTIFY_CREATED', (message: any) => {
                    //     console.log({
                    //         message
                    //     });

                    // });
                })
                .catch((e: any) => {
                    console.log('connectionServer failed: ', e)
                    const intervalId = setInterval(() => {
                        console.log('Try reconnect connectionServer');
                        if (connectionServer) {
                            try {
                                connectionServer.start()
                                    .done(function () {
                                        // console.log('Now connected, connectionServer ID=' + connectionServer.id);
                                        clearInterval(intervalId)
                                    })
                            } catch (error) {

                            }
                        }


                    }, reConnectTime);
                });
        }
        return (() => {
            if (connectionServer)
                connectionServer.stop();
        })
    }, [connectionServer]);

    return (
        <HubContext.Provider value={store}>
            {children}
        </HubContext.Provider>
    );
}
export {
    HubProvider,
    useHubContext
};

